import React from "react";
import { useTrelloPowerUpContext } from "../../external/trello-pu__core/trello-iframe/context";

function Modal() {
  const { trelloIFrame } = useTrelloPowerUpContext();

  return (
    <button onClick={() => trelloIFrame.getRestApi().clearToken()}>
      Deauthorize
    </button>
  );
}

export default Modal;
